<template>
  <div class="container-fluid m-0 p-0">
    <div class="row text-left bg-light border-bottom py-3 d-flex justify-content-between">
      <div class="col-auto">
        <h5 class="mb-0 font-weight-bold">MMCE Report</h5>
      </div>
      <div class="col-auto">
        <button class="btn btn-xs btn-outline-secondary px-2 mr-1" title="Go to Previous Page"
                @click="goBack">
          <span class="fas fa-backward"></span>
          Go Back
        </button>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "MMCEReport",
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
}
</script>



<style scoped>

</style>
